import React from "react";
import "./CategoryLayout.scss"
import all from "../../assets/cat-img/fork.svg"
import { useHistory } from "react-router";



const CategoryLayoutList = ({ selected = null, setSelected, data, showIcon = true, offerItems = false, categoryItems = false, allText = "All" }) => {
    const history = useHistory()

    return (
        <div className="CategoryLayoutList">
            <div className="data-list-cat-list">
                <div className={`cat-layout-m ${selected === null ? "selected" : ""}`}
                    onClick={() => {
                        setSelected(null)
                        if (categoryItems) {
                            history.push('/page/category/all')
                            localStorage.setItem("selected_cat", "null")
                            localStorage.setItem("selected_offer", "null")
                        }
                        if (offerItems) {
                            history.push('/page/offers/all')
                            localStorage.setItem("selected_offer", "null")
                            localStorage.setItem("selected_cat", "null")
                        }

                    }}>
                    {showIcon && <img alt="" src={all} className="cat-icon" />}
                    <div className="cat-layout-text">
                        {allText}
                    </div>
                </div>
                {data.map((category, key) => {
                    return (
                        <div className={`cat-layout-m ${selected && selected?.MenuCategoryID === category.MenuCategoryID ? "selected" : ""}`} key={key}
                            onClick={() => {
                                setSelected(category)
                                if (categoryItems) {
                                    history.push('/page/category/' + category.MenuCategoryID)
                                    localStorage.setItem("selected_cat", category.MenuCategoryID)
                                    localStorage.setItem("selected_offer", "null")

                                }
                                if (offerItems) {
                                    history.push('/page/offers/' + category.MenuCategoryID)
                                    localStorage.setItem("selected_offer", category.MenuCategoryID)
                                    localStorage.setItem("selected_cat", "null")
                                }

                            }}>
                            {showIcon && < img alt="" src={category.Image} className="cat-icon" />}
                            <div className="cat-layout-text">
                                {category?.Title?.en?.toLowerCase()}
                            </div>


                        </div>
                    )

                })}
            </div>
        </div>
    )

}
export default CategoryLayoutList